// import store from "@/store";
// import {
//   setSessionStorage,
//   setLocalStorage,
//   getSessionStorage,
//   getLocalStorage,
// } from "./utils/stage";
// const configData = {
//   platform: "pc",
//   app_id: "408a32e0ee5420b91916ceb38a31d85a",
//   kid: "666666666",
//   lang: "zh-cn",
// };
// setSessionStorage("message", JSON.stringify(configData));
// setLocalStorage("message", JSON.stringify(configData));
// store.dispatch("info/getGameInfo").then(() => {
// });
(function (w, d, n, a, j) {
	w[n] =
		w[n] ||
		function () {
			(w[n].a = w[n].a || []).push(arguments);
		};
	j = d.createElement('script');
	j.async = true;
	j.src =
		'https://qiyukf.com/script/fa9fdc3c4baf6db3cdfa77121d1cc324.js?hidden=1';
	d.body.appendChild(j);
})(window, document, 'ysf');
